module.exports = __webpack_public_path__ + "img/cover-product-te-hair-large.fdd2c8ba.jpg";